/* eslint-disable */

import React from 'react';
import { Switch, Route, Router } from 'react-router-dom';
import Auth from './Auth';
import Application from './Application';
import { history } from './history';

// import { useAuth } from '../../lib/auth'
function Mainroute() {
  // const { user } = useAuth();
  // console.log("user" , user)
 
  return (

    <Switch>
      {/* <Route path="/" exact component={LoginDedicated} /> */}
      {<Route path="/" component={Application} />}
      <Route component={Auth} />
      {/* <Route component={NotFound} /> */}
    </Switch>


  );
}

export default Mainroute;
